module.exports = __webpack_public_path__ + "img/Misty.1e96a052.png";